import { render, staticRenderFns } from "./root-services.vue?vue&type=template&id=6cac4ca3"
import script from "./root-services.vue?vue&type=script&lang=js"
export * from "./root-services.vue?vue&type=script&lang=js"
import style0 from "./root-services.vue?vue&type=style&index=0&id=6cac4ca3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports